import React, {useMemo, useState} from 'react';
import MessageReceiver, {
    makeOnDeleteAttachListener,
    makeOnDropAttachListener,
    makeOnSubmitListener
} from './MessageReceiver/MessageReceiver';
import AttachmentsPreviews from './AttachmentsPreviews/AttachmentsPreviews';
import {MessageFieldProps} from '@src/@types/components/Chat/MessageField';

export default function MessageField(props: MessageFieldProps) {
    const {
        leaveMessageFormComponent: LeaveMessageForm = MessageReceiver,
        onPostMessage,
        isInvalid,
        isDisabled,
        errorMessage,
        placeholder,
        size,
        apiRef,
        onError,
        itIsAnswerTo,
        onResetAnswerTo,
    } = props ?? {};

    const [attachments, setAttachments] = useState<File[]>([]);
    const [message, setMessage] = useState<string | null>(null);

    const [onDelete, onDrop, onSubmit] = useMemo(() => {
        return [
            makeOnDeleteAttachListener(setAttachments),
            makeOnDropAttachListener(setAttachments),
            makeOnSubmitListener(onPostMessage, attachments, setAttachments),
        ];
    }, [setAttachments, onPostMessage, attachments]);

    return <LeaveMessageForm
            defaultValue={message}
            onInput={setMessage}
            onDrop={onDrop}
            placeholder={placeholder ?? 'CommentsList.message'}
            isInvalid={isInvalid}
            isDisabled={isDisabled}
            errorMessage={errorMessage}
            filesPreviewSlot={
                <AttachmentsPreviews
                        attachment={attachments}
                        onDelete={onDelete}
                        isDisabled={isDisabled}
                />
            }
            onSubmit={onSubmit}
            size={size}
            apiRef={apiRef}
            onError={onError}
            itIsAnswerTo={itIsAnswerTo?.id}
            itIsAnswerToMessage={itIsAnswerTo}
            onResetAnswerTo={onResetAnswerTo}
    />;
}
